import { createGlobalStyle } from "styled-components";

import { down } from "~/src/config/vars";

export const url = "https://mediajasa.ideaca.today";
export const presentation_link = "https://mediajasa.ideaca.today";

export const global = {
    container_width: "var(--container-width)",

    border_radius: "var(--border-radius)",
    transition: "var(--transition)",

    /* z-index */
    zi_header: 20,

    container_padding: "var(--container-padding)",
    container_padding_minus: "var(--container-padding-minus)",
};

export const VarsGlobalStyle = createGlobalStyle`
    :root {
        --container-width: 84vw;
        ${down("xl")} {
            --container-width: 92vw;
        }

        --border-radius: 0;
        --transition: 0.2s;

        --container-padding: 15px;
        --container-padding-minus: -15px;
        ${down("sm")} {
            --container-padding: 5vw;
            --container-padding-minus: -5vw;
        }
    }
`;
